<script>
    import Layout from '../../layouts/main'
    import PageHeader from '@/components/page-header'
    import Sucursales from './popup/sucursales.vue'

    import { authWellyMethods } from "@/state/helpers";
    import { apiCore }  from '../../../constants'
    import axios from 'axios'

    export default {
        components: { Layout, PageHeader, Sucursales },
        props: {},
        data() {
            return {
                idResto: null,
                nameResto: null,
                restos: []
            };
        },
        computed: {
        },
        created: () => {
        },
        methods: {
            ...authWellyMethods,
            getRestos(){
                let url = `${apiCore}/api/welly/admin/restos`
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                //console.log(tok)
                axios
                .get(url, {
                        headers: {'Authorization': tok},
                })
                .then(r => r.data)
                .then(res => {
                    // eslint-disable-next-line
                    //console.log(res)
                    if (res.valid) {
                        // eslint-disable-next-line
                        //console.log(res)
                        this.restos = res.restos
                    } 
                })
            },
            viewSucursalesResto(idResto, nameResto){
                this.idResto = idResto
                this.nameResto = nameResto
                this.$bvModal.show('sucursalesResto'); 
            },
            editResto(idResto, nameResto){
                this.idResto = idResto
                this.nameResto = nameResto
                alert('Editando: ' + nameResto)
            },
            deleteResto(idResto, nameResto){
                this.idResto = idResto
                this.nameResto = nameResto
                alert('Eliminando: ' + nameResto)
            },
            showModalDeactivate(idResto, value){
                alert('Activar/Desactivar Resto: ' + idResto + ' valor:' + value)
            },
        },
        mounted() {
            this.chkToken()
            const user = JSON.parse(localStorage.getItem('user'));
            this.user = user
            this.getRestos()
        }
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card-welly">
                    <div class="row">
                        <div class="col-md-12 container-welly">
                            <div class="row scroll1">

                                <div class=" col-sm-12 col-md-12" style="margin: 10px 0 10px 0;">
                                    <h3 class="title-card">
                                        RESTAURANTES
                                    </h3>
                                    <div class="table-responsive">
                                        <table class="table mb-0">
                                            <thead class="table-head">
                                                <tr>
                                                    <th style="width:5%;">No.</th>
                                                    <th style="width:30%;">Nombre</th>
                                                    <th style="width:35%;">Dirección</th>
                                                    <th>Tipo</th>
                                                    <th class="center">Detalle</th>
                                                </tr>
                                            </thead>
                                            <tbody class="table-body">
                                                <tr v-for="(resto,index) in restos" :key="index">
                                                    <th>{{index + 1}}</th>
                                                    <th>
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-2">
                                                                <b-form class="form-check form-switch form-switch-lg" @click="showModalDeactivate(resto._id, resto.active)">
                                                                    <input
                                                                    class="form-check-input"
                                                                    id="input-1"
                                                                    type="checkbox"
                                                                    v-model="resto.active" :name="resto._id"
                                                                    />
                                                                </b-form> 
                                                            </div>

                                                            <div class="col-sm-12 col-md-10">
                                                                <b>{{resto.name}}</b>
                                                                <br/>
                                                                {{resto.description}}
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        {{resto.address}}
                                                        <br/>
                                                        <span style="font-size:0.7em;">{{resto.lat}}, {{resto.lng}}</span>
                                                    </th>
                                                    <th>
                                                        <img src="@/assets/images/special/ACC2_BLACK.svg" v-show="resto.glutenFree" style="margin: 0 5px 0 0;" height="20"/>
                                                        <img src="@/assets/images/special/VEGGIE_BLACK.svg" v-show="resto.veggie" style="margin: 0 5px 0 0;" height="20"/>
                                                        <img src="@/assets/images/special/CHEESE_BLACK.svg" v-show="resto.vegan" style="margin: 0 5px 0 0;" height="20"/>
                                                        <span v-show="!resto.glutenFree && !resto.veggie && !resto.vegan">Sin definir</span>
                                                    </th>
                                                    <th class="center">
                                                        <b-button class="button-icon" title="Ver sucursales de resto" @click="viewSucursalesResto(resto._id, resto.name)" >
                                                            <i class="bx bx-list-ul font-size-18"></i>
                                                        </b-button>
                                                        &nbsp;
                                                        <b-button class="button-icon" title="Editar resto" @click="editResto(resto._id, resto.name)" >
                                                            <i class="bx bx-edit font-size-18"></i>
                                                        </b-button>
                                                        <!--
                                                        &nbsp;
                                                        <b-button class="button-icon-secondary" title="Eliminar resto" @click="deleteResto(resto._id, resto.name)" >
                                                            <i class="bx bx-trash font-size-18"></i>
                                                        </b-button>
                                                        -->
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>

                            <br/>
                        </div>
                    </div>
                </div>  
            </div>
        </div>

        <br/><br/><br/>

        <Sucursales :idResto="idResto" :nameResto="nameResto"/>

    </Layout>
</template>

<style scoped>
</style>